import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import Img from 'components/common/Img'
import { HiOutlinePhone, HiOutlineLink } from 'react-icons/hi'
import { BsEnvelope } from 'react-icons/bs'
import clsx from 'clsx'

export default function QRCodeList({ _rawIntro, qrCodes }) {
	return (
		<section className="mx-auto grid max-w-screen-xl gap-x-12 gap-y-6 px-4 py-12 lg:grid-cols-2">
			<header className="richtext [&_h2]:h1 mx-auto max-w-md [&_h2]:text-ft-green">
				<SanityBlock body={_rawIntro} />
			</header>

			<div
				className={clsx(
					'flex snap-x snap-mandatory grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 md:grid',
					'<md:mx-[calc(50%-50vw)] <md:w-screen <md:overflow-x-auto <md:px-4 <md:pb-2',
				)}
			>
				{qrCodes?.map(
					(qrCode, key) =>
						qrCode && (
							<article
								className="flex shrink-0 grow-0 basis-[min(300px,80vw)] flex-col gap-5 overflow-hidden rounded-xl bg-white px-6 py-3"
								key={key}
							>
								<dl className="grow space-y-3">
									<dt className="h1 text-ft-green">{qrCode.title}</dt>
									{qrCode.subtitle && (
										<dd className="technical font-bold">{qrCode.subtitle}</dd>
									)}
								</dl>

								<div className="space-y-5">
									<figure>
										<Img image={qrCode.image} />
									</figure>

									<ul className="space-y-2">
										{qrCode.links?.map((link) => (
											<li key={link}>
												<a
													className="transiclo flex items-center gap-x-4 hover:text-ft-green"
													href={link}
												>
													<span className="text-2xl text-ft-green">
														{link.includes('mailto:') ? (
															<BsEnvelope />
														) : link.includes('tel:') ? (
															<HiOutlinePhone />
														) : (
															<HiOutlineLink />
														)}
													</span>

													<span>
														{link.includes(':') ? link.split(':').pop() : link}
													</span>
												</a>
											</li>
										))}
									</ul>
								</div>
							</article>
						),
				)}
			</div>
		</section>
	)
}
